<template>
    <!--
        作者：luoyiming
        时间：2019-10-24
        描述：服务管理
    -->
    <div class="product-list">
      <!--搜索表单-->
     
      
      <!--内容-->
      <div class="product-content">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="product_id" label="项目ID" width="60"></el-table-column>
            <!-- <el-table-column prop="productName" label="项目图">
              <template slot-scope="scope">
                <div class="product-info">
                  <div class="pic"><img v-img-url="scope.row.image[0].filePath" alt="" /></div>
                </div>
              </template>
            </el-table-column> -->
            <el-table-column prop="city_text.merger_name" label="代理城市"></el-table-column>
            
  
            <!-- <el-table-column prop="supplier.name" label="商户名称"></el-table-column> -->
            <el-table-column prop="productPrice" label="代理价格"></el-table-column>
            <el-table-column prop="supplier.name" label="商户名称"></el-table-column>
            <!-- <el-table-column prop="service.name" label="项目类型"></el-table-column>
            <el-table-column prop="serviceCategory" label="项目分类"></el-table-column> -->
           
            <!-- <el-table-column prop="isClock" label="是否加钟">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.isClock == 0">正常服务</el-tag>
                <el-tag v-if="scope.row.isClock == 1" type="danger">加钟服务</el-tag>
              </template>
            </el-table-column> -->
          
            
            <el-table-column prop="createTime" label="发布时间"></el-table-column>
            
           
          </el-table>
        </div>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"></el-pagination>
      </div>
      <div class="common-button-wrapper" style="height: 100px;">
        <el-button size="small" type="info" @click="cancelFunc">返回</el-button>
      
      </div>
    </div>
    
  </template>
  
  <script>
  import PorductApi from "@/api/product.js";
  export default {
    data() {
      return {
        showViewer: false, // 显示查看器
        /*切换菜单*/
        activeName: "",
        /*切换选中值*/
        activeIndex: "0",
        /*是否正在加载*/
        loading: true,
        /*一页多少条*/
        pageSize: 10,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索参数*/
        searchForm: {
          productName: "",
          serviceId: "",
          isClock: "",
          categoryId: "",
          shopSupplierId: "",
          productStatus: "",
          serviceCategory: ''
        },
        /*列表数据*/
        tableData: [],
        /*全部分类*/
        categoryList: [],
        serviceList: [],
        serviceCategory: [],
        supplierList: [],
        /*服务统计*/
        product_count: {}
      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {
     
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.loading = true;
        self.curPage = val;
        self.getData();
      },
  
      /*每页多少条*/
      handleSizeChange(val) {
        this.pageSize = val;
        this.getData();
      },
      cancelFunc(){
        this.$router.back()
      },
      /*切换菜单*/
      handleClick(tab, event) {
        let self = this;
        self.curPage = 1;
        self.getData();
      },
  
      /*获取列表*/
      getData() {
        let self = this;
        let Params = {};
        Params.pageIndex = self.curPage;
        Params.product_id=self.$route.query.product_id
        self.loading = true;
       
        PorductApi.getCityAgentPrice(Params, true)
          .then(data => {
            console.log(data)
            self.loading = false;
            self.tableData = data.data.data;
            // self.categoryList = data.data.category;
            // self.serviceList = data.data.serviceList;
            // self.serviceCategory = data.data.serviceCategory || [];
            // if (data.data.serviceCategory) {
            //   self.tableData.forEach(tableItem => {
            //     self.serviceCategory.forEach(categoryItem => {
            //       if (tableItem.serviceCategory == categoryItem.id) {
            //         tableItem.serviceCategory = categoryItem.value;
            //       }
            //     });
            //   });
            // }
            // self.supplierList = data.data.supplierList;
            // // self.productIds = data.data.productIds;
            self.totalDataNumber = data.data.total;
            // self.product_count = data.data.product_count;
          })
          .catch(error => {
            self.loading = false;
          });
      },
      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getData();
      },
      addClick(row) {
        this.$router.push("/product/product/add");
      },
      /*打开编辑*/
      editClick(row) {
        this.$router.push({
          path: "/product/product/edit",
          query: {
            product_id: row.product_id,
            scene: "edit"
          }
        });
      },
      /*删除*/
      delClick: function (row) {
        let self = this;
        self
          .$confirm("删除后将移动到回收站，确定删除该记录吗?", "提示", {
            type: "warning"
          })
          .then(() => {
            PorductApi.delProduct({
              product_id: row.product_id
            }).then(data => {
              self.$message({
                message: "删除成功",
                type: "success"
              });
              self.getData();
            });
          });
      }
    }
  };
  </script>
  <style lang="scss">
  .product-list {
  
    /* switch按钮样式 */
    .switch .el-switch__label {
      position: absolute;
      display: none;
      color: #fff !important;
    }
  
    /*打开时文字位置设置*/
    .switch .el-switch__label--right {
      z-index: 1;
    }
  
    /* 调整打开时文字的显示位子 */
    .switch .el-switch__label--right span {
      margin-right: 15px;
    }
  
    /*关闭时文字位置设置*/
    .switch .el-switch__label--left {
      z-index: 1;
    }
  
    /* 调整关闭时文字的显示位子 */
    .switch .el-switch__label--left span {
      margin-left: 9px;
    }
  
    /*显示文字*/
    .switch .el-switch__label.is-active {
      display: block;
    }
  
    /* 调整按钮的宽度 */
    .switch.el-switch .el-switch__core,
    .el-switch .el-switch__label {
      width: 50px !important;
      margin: 0;
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/product/product/newprice.vue